/*
  Yotpo average score: always show one decimal place (5 -> 5.0, 4 -> 4.0;
  4.7 is unchanged). Yotpo has no setting for this - the Star Rating widget
  only toggles the average score on/off - so the number is reformatted after
  Yotpo renders it.

  Covers both places a score appears:
    .yotpo-sr-bottom-line-score  Star Rating widget (product cards on
                                 collection / search pages)
    .yotpo-bottom-line-score     Reviews widget (the large average in the
                                 PDP reviews section)

  Yotpo renders asynchronously and keeps adding widgets as cards lazy-load,
  infinite-scroll or get re-rendered by filtering, so one observer on the
  page catches every new or re-rendered score. Only a bare number between 0
  and 5 is touched, and writing the same value again is skipped, so the
  observer can't loop.

  Formatting runs directly in the observer callback - not via
  requestAnimationFrame, which browsers pause in background tabs (products
  opened in a new tab would keep "5" until switched to). Observer callbacks
  run as microtasks once per batch of DOM changes, before the next paint, so
  the unformatted number is never drawn.
*/
(function () {
  if (window.klimYotpoScoreFormat) return;
  window.klimYotpoScoreFormat = true;

  var SELECTOR = '.yotpo-sr-bottom-line-score, .yotpo-bottom-line-score';

  function formatAll() {
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      if (el.children.length) return;
      var text = el.textContent.trim();
      if (!/^\d+(\.\d+)?$/.test(text)) return;
      var score = Number(text);
      if (score < 0 || score > 5) return;
      var formatted = score.toFixed(1);
      if (text !== formatted) el.textContent = formatted;
    });
  }

  formatAll();
  new MutationObserver(formatAll).observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();
